var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var GenericVisualParams_1;
import { AggregateColumn } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { VisualParams } from './visualParams';
import { VisualType } from '@symon-ai/wisepipe-base-computation';
import { GenericVisualSubType } from '@symon-ai/wisepipe-base-computation';
const schema = {
    $id: 'urn:wisepipe-common-computation:GenericVisualParams',
    type: 'object',
    properties: {
        subType: { type: 'string', enum: Object.values(GenericVisualSubType) },
        xAxis: { type: 'string', minLength: 1 },
        series: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true, minItems: 1 },
        descriptions: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true },
        aggOps: {
            type: 'array',
            items: {
                type: 'string',
                enum: Object.values(AggregateColumn.Operation)
            },
            anyOf: [
                { minItems: 0, maxItems: 0 },
                { minItems: { $data: '1/series/length' }, maxItems: { $data: '1/series/length' } }
            ]
        },
        gradient: { type: 'boolean' },
        shadow: { type: 'boolean' }
    },
    required: ['subType', 'xAxis', 'series', 'aggOps']
};
let GenericVisualParams = GenericVisualParams_1 = class GenericVisualParams extends VisualParams {
    constructor(args) {
        super({
            ...args,
            type: VisualType.Generic
        });
        this.subType = args.subType;
        this.xAxis = args.xAxis;
        this.series = args.series;
        this.aggOps = args.aggOps;
        if (args.descriptions)
            this.descriptions = args.descriptions;
        if (args.gradient)
            this.gradient = args.gradient;
        if (args.shadow)
            this.shadow = args.shadow;
        JSON.validate(this, GenericVisualParams_1);
    }
    static get xAxisAlias() {
        return 'xAxis';
    }
    static getSeriesAlias(index) {
        return `series_${index}`;
    }
    static getDescriptionsAlias(index) {
        return `descriptions_${index}`;
    }
    getFields() {
        if (this.aggOps.length > 0) {
            return [
                { source: this.xAxis, alias: GenericVisualParams_1.xAxisAlias },
                ...this.series.map((s, i) => {
                    return {
                        source: s,
                        alias: GenericVisualParams_1.getSeriesAlias(i),
                        aggOp: this.aggOps[i]
                    };
                })
            ];
        }
        else {
            const fields = [{ source: this.xAxis, alias: GenericVisualParams_1.xAxisAlias }];
            this.series.map((s, i) => {
                fields.push({ source: s, alias: GenericVisualParams_1.getSeriesAlias(i) });
            });
            if (this.descriptions) {
                this.descriptions.map((s, i) => {
                    fields.push({ source: s, alias: GenericVisualParams_1.getDescriptionsAlias(i) });
                });
            }
            return fields;
        }
    }
    setFinalQuery(query, type, tableName) {
        return query;
    }
};
GenericVisualParams = GenericVisualParams_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(VisualType.Generic)
], GenericVisualParams);
export { GenericVisualParams };
//# sourceMappingURL=genericVisualParams.js.map